import { render } from "./structuresDialog.vue?vue&type=template&id=68823a59&scoped=true"
import script from "./structuresDialog.vue?vue&type=script&lang=js"
export * from "./structuresDialog.vue?vue&type=script&lang=js"

import "./structuresDialog.vue?vue&type=style&index=0&id=68823a59&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68823a59"]])

export default __exports__